<script>
import { SimpleBar } from "simplebar-vue3";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { chatData, chatMessagesData, lineChart } from "../atendimento/data-chat";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Detalhes Chamado",
    meta: [
      {
        name: "Atendimento",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    SimpleBar,
    Vue3ChartJs,
    Loader
  },
  data() {
    return {
      title: "Detalhes Chamado",
      items: [
        {
          text: "Atendimentos",
          href: "/atendimentos/listprod",
        },
        {
          text: "Detalhes Chamado",
          active: true,
        },
      ],
      idData: 0,
      submitted: false,
      updatingRight: true,
      chatChamadoData: {},
      chatsData: null,


      form: {
        message: "",
      },
      username: "Clientes Testes 999",
      chatData: chatData,
      chatMessagesData: chatMessagesData,
      lineChart: lineChart,
    };
  },
  validations: {
    form: {
      message: {
        required: helpers.withMessage("Message is required", required),
      },
    },
  },
  methods: {

    encerrarChamado(){
      console.log('encerrarChamado')


      Swal.fire({
        position: "center",
        icon: "question",
        title: "Encerrar Chamado",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.post(`${getBaseUrl()}api/chatencerra`, {
            iddata: this.idData
          }).then((res) => {

            console.log('then axios')
            console.log(res.data)

            this.chatChamadoData = res.data[0]

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Chamado encerrado com sucesso",
              showConfirmButton: false,
              timer: 1500
            })
          })


        }
      })



    },


    carregarDados() {
      api.get(`${getBaseUrl()}api/chatdetail`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios chatdetail')
        console.log(res)

        this.chatChamadoData = res.data[0]
        this.chatsData = res.data[1]

        this.title = `Detalhes Chamado (${this.idData})`

        this.updatingRight = false

        // this.chatsDataGeral = res.data[0]
        // this.chatsDataGeral.forEach((value) => {
        //   value.created_at = moment(value.created_at).format('DD/MM/YYYY HH:mm:ss')
        // })
        // this.updatingRight = false
      })


      // var container1 = document.querySelector(
      //     "#chat-list .simplebar-content-wrapper"
      // );
      // container1.scrollTo({ top: 500, behavior: "smooth" });
      //
      // var container2 = document.querySelector(
      //     "#containerElement .simplebar-content-wrapper"
      // );
      // container2.scrollTo({ top: 500, behavior: "smooth" });
    },



    chatUsername(name) {
      this.username = name;
      this.usermessage = "Olá";
      this.chatMessagesData = [];
      const currentDate = new Date();

      this.chatMessagesData.push({
        name: this.username,
        message: this.usermessage,
        time: currentDate.getHours() + ":" + currentDate.getMinutes(),
      });

      this.chatMessagesData.push({
        align: 'right',
        name: 'BIA',
        message: 'Olá, sou a Bia, inteligência artificial da _ParEmpresa08_, como posso ajudar?',
        time: currentDate.getHours() + ": " + currentDate.getMinutes(),
      });
    },

    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {
        const message = this.form.message;
        const currentDate = new Date();
        this.chatMessagesData.push({
          align: "right",
          name: "Henry Wells",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.form = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.value.getScrollElement().scrollTop =
              this.$refs.current.SimpleBar.value.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  mounted() {
    console.log('mounted_chat_detalhes')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Novo Chamado`
      this.updatingRight = false
    }

  },
};
</script>

<template>
  <Layout>


    <PageHeader :title="title" :items="items" :status="chatChamadoData.status"/>


    <div class="d-lg-flex">
      <div class="chat-leftsidebar me-lg-4">
        <div class>
          <div class="py-4 border-bottom">
            <div class="d-flex">
              <div class="align-self-center me-3">
                <img
                    src="@/assets/images/users/avatar-1.jpg"
                    class="avatar-xs rounded-circle"
                    alt
                />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-15 mt-0 mb-1">Status Automação</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Ativo
                </p>
              </div>

              <b-dropdown
                  menu-class="dropdown-menu-end"
                  class="chat-noti-dropdown active"
                  right
                  variant="white"
              >
                <template v-slot:button-content>
                  <i class="bx bx-bell bx-tada"></i>
                </template>
                <b-dropdown-item>Configurações</b-dropdown-item>
                <b-dropdown-item>Interromper Automação</b-dropdown-item>
                <!--                <b-dropdown-item>Something else here</b-dropdown-item>-->
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="search-box chat-search-box py-4">
          <div class="position-relative">
            <input id="inputPesquisa" type="text" class="form-control" placeholder="Enter para pesquisar..." />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>

        <div class="chat-leftsidebar-nav">
          <b-tabs pills fill content-class="py-4">
            <b-tab title="Tab 1" active  disabled>
              <template v-slot:title>
                <i class="bx bx-chat font-size-20 d-sm-none"></i>
                <span class="d-none d-sm-block">Pendentes</span>
              </template>
              <b-card-text>
                <div>
                  <!--                  <h5 class="font-size-14 mb-3">Recent</h5>-->
                  <SimpleBar style="max-height: 410px" id="chat-list">
                    <ul class="list-unstyled chat-list">
                      <li
                          class=""
                          v-for="data of chatData"
                          :key="data.id"
                          @click="chatUsername(data.name)"
                          :class="{ active: username == data.name }"
                      >
                        <a href="javascript: void(0);" >
                          <div class="d-flex">
                            <div class="align-self-center me-3">
                              <i
                                  :class="`mdi mdi-circle text-${data.color} font-size-10`"
                              ></i>
                            </div>
                            <div
                                class="align-self-center me-3"
                                v-if="data.image"
                            >
                              <img
                                  :src="`${data.image}`"
                                  class="rounded-circle avatar-xs"
                                  alt
                              />
                            </div>
                            <div
                                class="avatar-xs align-self-center me-3"
                                v-if="!data.image"
                            >
                              <span
                                  class="
                                  avatar-title
                                  rounded-circle
                                  bg-soft bg-primary
                                  text-primary
                                "
                              >{{ data.name.charAt(0) }}</span
                              >
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                {{ data.name }}
                              </h5>
                              <p class="text-truncate mb-0">
                                {{ data.message }}
                              </p>
                            </div>
                            <div class="font-size-11">{{ data.time }}</div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </SimpleBar>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab  disabled>
              <template v-slot:title>
                <i class="bx bx-group font-size-20 d-sm-none"></i>
                <span class="d-none d-sm-block">Finalizados</span>
              </template>
              <b-card-text>
                <h5 class="font-size-14 mb-3">Groups</h5>
                <ul class="list-unstyled chat-list">
                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >G</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0600</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >R</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0608</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >M</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0700</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >A</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0001</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >B</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0002</h5>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </b-card-text>
            </b-tab>

          </b-tabs>
        </div>
      </div>


      <div class="w-100 user-chat" v-if="updatingRight">

        <Loader style="min-height: 300px;">
        </Loader>

      </div>
      <div class="w-100 user-chat" v-if="!updatingRight">
        <div class="card">
          <div class="p-4 border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-1">{{ chatChamadoData.nome }}</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>

                  {{ formatDateTime(chatChamadoData.updated_at) }}

                </p>
              </div>
              <div class="col-md-8 col-3">
                <ul class="list-inline user-chat-nav text-end mb-0">
                  <li class="list-inline-item d-none d-sm-inline-block">
                    <b-dropdown
                        menu-class="dropdown-menu-md dropdown-menu-end"
                        variant="white"
                        right
                        toggle-class="nav-btn"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-search-alt-2"></i>
                      </template>
                      <form class="p-3">
                        <div class="form-group m-0">
                          <div class="input-group">
                            <input
                                id="inputPesqCli"
                                type="text"
                                class="form-control"
                                placeholder="Pesquisar..."
                                aria-label="Recipient's username"
                            />
                            <div class="input-group-append">
                              <button class="btn btn-primary" type="submit">
                                <i class="mdi mdi-magnify"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-dropdown>
                  </li>
                  <li class="list-inline-item d-none d-sm-inline-block">
                    <b-dropdown
                        toggle-class="nav-btn"
                        menu-class="dropdown-menu-end"
                        right
                        variant="white"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-cog"></i>
                      </template>
                      <b-dropdown-item>Detalhes Cliente</b-dropdown-item>
                      <b-dropdown-item>Perfil Representante</b-dropdown-item>
                      <b-dropdown-item>Perfil Supervisor</b-dropdown-item>
                      <b-dropdown-item>Deletar</b-dropdown-item>
                    </b-dropdown>
                  </li>

                  <li class="list-inline-item">
                    <b-dropdown
                        toggle-class="nav-btn"
                        menu-class="dropdown-menu-end"
                        right
                        variant="white"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-dots-horizontal-rounded"></i>
                      </template>
                      <b-dropdown-item @click="encerrarChamado" :disabled="chatChamadoData.status !== 'AB'">Encerrar Chamado</b-dropdown-item>
                      <!--                      <b-dropdown-item>Another action</b-dropdown-item>-->
                      <!--                      <b-dropdown-item>Something else</b-dropdown-item>-->
                    </b-dropdown>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="chat-users">
            <div class="chat-conversation p-3">
              <SimpleBar
                  style="max-height: 470px"
                  id="containerElement"
                  ref="current"
              >
                <ul class="list-unstyled">
                  <!--                  <li>-->
                  <!--                    <div class="chat-day-title">-->
                  <!--                      <span class="title">Today</span>-->
                  <!--                    </div>-->
                  <!--                  </li>-->
                  <li v-for="data of chatsData"
                      :key="data.id"
                      :class="data.interna === 1 ? 'right' : '' ">

                    <div class="conversation-list">
                      <!--                      <b-dropdown v-if="data.align === 'right'"-->
                      <!--                          variant="white"-->
                      <!--                          menu-class="dropdown-menu-end">-->
                      <!--                        <template v-slot:button-content>-->
                      <!--                          <i class="bx bx-dots-vertical-rounded"></i>-->
                      <!--                        </template>-->
                      <!--                        <b-dropdown-item>Editar Automação</b-dropdown-item>-->
                      <!--                        <b-dropdown-item>Save</b-dropdown-item>-->
                      <!--                        <b-dropdown-item>Forward</b-dropdown-item>-->
                      <!--                        <b-dropdown-item>Delete</b-dropdown-item>-->
                      <!--                      </b-dropdown>-->
                      <div class="ctext-wrap">

                        <div class="conversation-name" v-if="data.interna === 0" >{{ chatChamadoData.nome }}</div>
                        <div class="conversation-name" v-else> Interna </div>

                        <p>{{ data.texto }} </p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ formatDateTime(data.data) }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </SimpleBar>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                        id="inputMessageBia"
                        type="text"
                        v-model="form.message"
                        class="form-control chat-input rounded"
                        placeholder="Bia, enviar mensagem..."
                        :class="{
                        'is-invalid': submitted && v$.form.message.$error,
                      }"
                    />
                    <div
                        v-if="submitted && v$.form.message.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="v$.form.message.required.$message">{{
                          v$.form.message.required.$message
                        }}</span>
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">

                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              title="Imagens"
                          >
                            <i class="mdi mdi-file-image-outline"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              title="Arquivos"
                          >
                            <i class="mdi mdi-file-document-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button
                      type="submit"
                      disabled="true"
                      class="btn btn-primary btn-rounded chat-send w-md">
                    <span class="d-none d-sm-inline-block me-2">Enviar</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--            <h4 class="card-title mb-4">Line Chart</h4>-->
            <div class="row text-center">
              <div class="col-sm-4">
                <h5 class="mb-0">541</h5>
                <p class="text-muted">Chamados no Ano</p>
              </div>
              <div class="col-sm-4">
                <h5 class="mb-0">41</h5>
                <p class="text-muted">Pendentes</p>
              </div>
              <div class="col-sm-4">
                <h5 class="mb-0">500</h5>
                <p class="text-muted">Finalizados</p>
              </div>
            </div>
            <!-- Line Chart -->

            <vue3-chart-js
                class="chartjs-chart"
                v-bind="{ ...lineChart }"
            ></vue3-chart-js>
          </div>
        </div>
      </div>

    </div>


  </Layout>
</template>
